<template>
  <span>
    <router-link v-if="!disable" :to="to">
      <slot />
    </router-link>
    <slot v-else />
  </span>
</template>

<script>
export default {
  name: "CommonLink",
  props: {
    to: {
      type: String,
      default: "/",
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
